"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 16 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var Currency_1 = require("../model/Currency");

var CurrencyConverter_1 = require("./CurrencyConverter");

var CurrencyRateConverter_1 = require("./CurrencyRateConverter");
/**
 * Implementation of {@link CurrencyConverter}.
 *
 * @author RV
 * @author JMe
 */


var CurrencyConverterImpl =
/*#__PURE__*/
function (_CurrencyConverter_1$) {
  _inherits(CurrencyConverterImpl, _CurrencyConverter_1$);

  function CurrencyConverterImpl(currencyRateConverter) {
    var _this;

    _classCallCheck(this, CurrencyConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CurrencyConverterImpl).call(this));
    _this.currencyRateConverter = currencyRateConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CurrencyConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new Currency_1.Currency(Currency_1.Currency.schema.id.valueOf(conversions.documentToClassId(source)), Currency_1.Currency.schema.externalId.valueOfField(source), Currency_1.Currency.schema.code.valueOfField(source), Currency_1.Currency.schema.name.valueOfField(source), Currency_1.Currency.schema.shortName.valueOfField(source), conversions.asObjectList(source, 'rates', function (object) {
        return _this2.currencyRateConverter.toObject(object, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        code: source.code,
        name: source.name,
        shortName: source.shortName
      });
      Object.assign(result, {
        rates: conversions.asObjectArray(source, 'rates', function (currencyRate) {
          return _this3.currencyRateConverter.toDocument(currencyRate, conversions);
        })
      });
      return result;
    }
  }]);

  return CurrencyConverterImpl;
}(CurrencyConverter_1.CurrencyConverter);

CurrencyConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [CurrencyRateConverter_1.CurrencyRateConverter])], CurrencyConverterImpl);
exports.CurrencyConverterImpl = CurrencyConverterImpl;